import apiClient from './apiClient.js';

/**
 * Search for place autocomplete suggestions
 * @param {string} input - Search query
 * @returns {Promise<Array>} Array of place predictions
 */
export const searchPlaces = async (input) => {
    try {
        const response = await apiClient.get('/places/autocomplete', {
            params: { input },
        });
        return response.data.predictions || [];
    } catch (error) {
        console.error('Error searching places:', error);
        throw error;
    }
};

/**
 * Get detailed information about a place
 * @param {string} placeId - Google Place ID
 * @returns {Promise<Object>} Place details including maps URL
 */
export const getPlaceDetails = async (placeId) => {
    try {
        const response = await apiClient.get('/places/details', {
            params: { place_id: placeId },
        });
        return response.data.place;
    } catch (error) {
        console.error('Error getting place details:', error);
        throw error;
    }
};

